<div [class.mobile]="deviceService.isMobile()" class="widget-merchant-processing">
  <div *ngIf="!safePaymentUrl || isAccountPayment" class="processing-wrapper">
    <div class="processing">{{'payment-form.please-wait' | translate}}</div>
    <spinner2></spinner2>
  </div>

  <div *ngIf="error" class="error text-center">{{ error | translate }}</div>

  <ng-template [ngIf]="loaded && !isAccountPayment">

    <iframe (load)="watchFrameLoad()" *ngIf="safePaymentUrl" [class.mobile]="deviceService.isMobile()" [src]="safePaymentUrl"
            _allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" _allowfullscreen
            class="tinkoff-frame" frameborder="0" id="payment-frame">
    </iframe>
  </ng-template>
</div>
